settings_module = settings_module or {}
settings_module.triggers = (lang)->

    Gettext._locale_data = {}
    gt.try_load_lang_po('/static/frontend_bat/app-backbone/locale/' + LOCALE_LOOKUP.gettext[lang] + '/messages.po')


    tabHandler('#place-tab')

    $('.remove-trigger').click (e) ->
        e.preventDefault()
        $button = $(@)
        $tr = $button.closest('tr')
        action = gettext("Delete alarm?")
        widget_name = $tr.find('td:first').text()
        if confirm("#{action} (#{widget_name})")
            window.location.href = "#{window.location.pathname}/delete/#{$button.data('trigger_id')}"
